module.exports = __webpack_public_path__ + "img/green-triangle-right.cffbc766.svg";